/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
// import matchSorter from "match-sorter";
import { isEmpty } from "lodash";
import styled from "styled-components";
// import ReactTable from "react-table";
import View from "../../styled/View";
// import Map from "../common/Map";

// import { PhoneNumber as phoneNumber } from "../../../helpers";
// import Loading from "../../common/Loading";
// import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";
// import TableActions from "../../common/TableActions";
// import { divide } from "lodash";

import { formatDate } from "../../../helpers/date";

const CollectionView = ({ customer }) => {
  let data = {};
  if (!isEmpty(customer)) {
    data = {
      "Account Rep": customer.collections?.salesperson?.full_name || "--",
      Current: customer.collections?.agingBucket1 || 0,
      "31-60 Days": customer.collections?.agingBucket2 || 0,
      "61-90 Days": customer.collections?.agingBucket3 || 0,
      "90+ Days": customer.collections?.agingBucket4 || 0,
      "Total Balance": customer.collections?.totalBalance || 0,
      "Last Updated": customer.collections?.lastUpdated || "--"
    };
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  });
  if (!isEmpty(customer.collections)) {
    return (
      <CustomerViewStyles>
        <div className="content-wrapper">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: `3px solid ${(props) => props.theme.blue_g}`
            }}
          >
            <fieldset style={{ width: "50%" }}>
              <legend>Account Balance Info</legend>
            </fieldset>
            <fieldset style={{ width: "50%" }}>
              <legend style={{ paddingBottom: "2px", textAlign: "right" }}>
                <span>
                  Last Updated:{" "}
                  {data["Last Updated"]
                    ? formatDate(data["Last Updated"], "MM/dd/yyyy")
                    : "--"}
                </span>
              </legend>
            </fieldset>
          </div>
          {/* style={{display: "flex", justifyContent: "space-between"}} */}
          <div className="data-container-collection">
            {Object.keys(data).map((key, i) => {
              if (
                key === "Current" ||
                key === "31-60 Days" ||
                key === "61-90 Days" ||
                key === "90+ Days"
              ) {
                return (
                  <div key={i} className="data">
                    <label htmlFor={key}>{key}</label>
                    {formatter.format(data[key])}
                  </div>
                );
              }
              if (key === "Total Balance") {
                return (
                  <div key={i} className="data">
                    <label htmlFor={key}>{key}</label>
                    <span id={key}>{formatter.format(data[key])}</span>
                  </div>
                );
              }
              if (key === "Last Updated") {
                return "";
              }
              return (
                <div key={i} className="data">
                  <label htmlFor={key}>{key}</label>
                  {data[key]}
                </div>
              );
            })}
          </div>
        </div>
      </CustomerViewStyles>
    );
  }

  return "";
};

const CustomerViewStyles = styled(View)`
  display: block;
  @media screen and (max-width: 769px) {
    .data-container-collection {
      display: grid;
      margin: 0 5px;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        "data"
        "map";
    }
    .content-wrapper:nth-child(2) {
      display: none;
    }
  }
`;

CollectionView.propTypes = {
  customer: PropTypes.object.isRequired
};

export default CollectionView;

// grid-template-columns: 1fr 2fr;
// grid-template-areas:
//   "data data data"
//   "map map map";
// & > .content-wrapper:first-child {
//   min-height: 30vh;
// }
